import { FileText } from "lucide-react";
import { useState } from "react";
import Modal from "../../../../components/Modal";

interface ObservacoesModalProps {
  descricao: string;
}

const ObservacoesModal = ({ descricao }: ObservacoesModalProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="flex items-center justify-center rounded-full p-2 text-neutral-600 transition-colors hover:bg-neutral-100 hover:text-neutral-800"
        title="Ver observações"
      >
        <FileText size={16} />
      </button>

      <Modal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title="Observações"
      >
        <div className="p-4">
          <p className="whitespace-pre-wrap text-neutral-700">
            {descricao || "Nenhuma observação disponível."}
          </p>
        </div>
      </Modal>
    </>
  );
};

export default ObservacoesModal;
